import { render, staticRenderFns } from "./freightDriver.vue?vue&type=template&id=54aecae3&scoped=true&"
import script from "./freightDriver.vue?vue&type=script&lang=js&"
export * from "./freightDriver.vue?vue&type=script&lang=js&"
import style0 from "./freightDriver.vue?vue&type=style&index=0&id=54aecae3&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54aecae3",
  null
  
)

export default component.exports